import { useEffect, useRef } from 'react';

import { SettingsButton } from '@cast/design-system';

import { useRegisterClustersTableSettings } from '../../_context/ClustersTableSettingsContext';

/** Renders inside DataTable outerHeader so SettingsButton has TableContext. */
export const ClustersTableSettingsBridge = () => {
  const registerOpenSettings = useRegisterClustersTableSettings();
  const settingsButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    registerOpenSettings(() => {
      settingsButtonRef.current?.click();
    });
  }, [registerOpenSettings]);

  return (
    <SettingsButton
      ref={settingsButtonRef}
      testId="clusters-view-settings"
      tabIndex={-1}
      sx={{
        position: 'absolute',
        width: 1,
        height: 1,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
      }}
    />
  );
};
